import { faTicket } from '@fortawesome/pro-solid-svg-icons';
import { SearchHit } from 'api/search';
import { SearchHitHighlightOrDocumentValue } from 'components/search/SearchHitHighlightOrDocumentValue';
import * as SearchResults from 'components/search/SearchResults';
import { useSearchResultsProps } from 'components/tasks/utils/useLinkSearchResults';
import { Ticket } from 'types/domain';

interface TicketResultsProps {
    onSelect: (hit: SearchHit<Ticket>) => void;
}
const TicketResults = ({ onSelect }: TicketResultsProps) => {
    const { isEmpty, getKey, data } = useSearchResultsProps('tickets');

    if (isEmpty) {
        return null;
    }

    return (
        <SearchResults.Root>
            <SearchResults.Title>Tickets</SearchResults.Title>
            {data.hits.map(hit => {
                return (
                    <SearchResults.ListItem
                        key={getKey(hit.document.id)}
                        onClick={() => onSelect(hit)}
                    >
                        <SearchResults.Icon icon={faTicket} />
                        <SearchHitHighlightOrDocumentValue
                            hit={hit}
                            documentKey="uid_suffix"
                            className={'font-medium'}
                        />
                        <SearchHitHighlightOrDocumentValue
                            hit={hit}
                            documentKey="contact.first_name"
                            className="text-gray-500"
                        />
                        <SearchHitHighlightOrDocumentValue
                            hit={hit}
                            documentKey="contact.last_name"
                            className="text-gray-500"
                        />
                    </SearchResults.ListItem>
                );
            })}
        </SearchResults.Root>
    );
};

export { TicketResults };
